import React, { memo } from 'react';

const Version = () => {
    return <span style={{ float: 'right' }}>Version : v 2024.08.17.0</span>;
};

export default memo(Version);
